/* eslint-disable */
/**
 * Import from node_modules
 */
/**
 * Import site scripts
 */
import PredictiveSearch from './site/predictive-search';
import SplideExample from './site/_splide-example';
import Mix from './site/mix';
import Sliders from './site/sliders';
import EqualHeights from './site/equalHeights';
import ProductGrid from './site/product-grid';
import Collection from './site/collection';
import Header from './site/header';
import ProductReviews from './site/product-reviews';
//import RechargeCustomSubscription from './site/recharge-custom-subscription';
import AnimationOnScroll from './site/animation-on-scroll'
import Login from './site/login';
import Account from './site/account';
import Buybox from './site/buybox';
import ProductGallery from './site/product-gallery';
import Article from './site/article';
import KlaviyoNewsletter from './site/klaviyo-newsletter';
import AddToCart from './site/addToCart';
import Contact from './site/contact';
import PillsCarousel from './site/pills-carousel'; 
import TestimonialsCarousel from './site/testimonials'; 
import MediaCarousel from './site/media-carousel'; 
import ExpertEndorsement from './site/expert-endorsement';
import SocialProof from './site/social-proof';
import IngredientsSlider from './site/ingredients-slider';
import Accordion from './site/accordion';
import WhitePaperContent from './site/white-paper-content';
import RebuyOos from './site/rebuy-oos';

/**
 * Init site scripts
 */

// Run each module's init in isolation so one module throwing doesn't
// prevent the rest of the site (e.g. the header/hamburger menu or the
// buybox variant selectors) from initializing.
function safeInit(name, module) {
	try {
		module.init();
	} catch (e) {
		console.error(`[site.js] ${name}.init() failed:`, e);
	}
}

document.addEventListener('DOMContentLoaded', function() {

	// custom
	safeInit('PillsCarousel', PillsCarousel);
	safeInit('TestimonialsCarousel', TestimonialsCarousel);
	safeInit('MediaCarousel', MediaCarousel);
	safeInit('ExpertEndorsement', ExpertEndorsement);
	safeInit('SocialProof', SocialProof);
	safeInit('IngredientsSlider', IngredientsSlider);
	safeInit('Accordion', Accordion);
	safeInit('WhitePaperContent', WhitePaperContent);
	safeInit('RebuyOos', RebuyOos);

	// legacy
	safeInit('PredictiveSearch', PredictiveSearch);
	safeInit('SplideExample', SplideExample);
	safeInit('Mix', Mix);
	safeInit('Sliders', Sliders);
	safeInit('EqualHeights', EqualHeights);
	safeInit('ProductGrid', ProductGrid);
	safeInit('Collection', Collection);
	safeInit('Header', Header);
	safeInit('ProductReviews', ProductReviews);
	//safeInit('RechargeCustomSubscription', RechargeCustomSubscription);
	safeInit('AnimationOnScroll', AnimationOnScroll);
	safeInit('Login', Login);
	safeInit('Account', Account);
	safeInit('Buybox', Buybox);
	safeInit('Article', Article);
	safeInit('ProductGallery', ProductGallery);
	safeInit('KlaviyoNewsletter', KlaviyoNewsletter);
	safeInit('AddToCart', AddToCart);
	safeInit('Contact', Contact);
});
